import React from 'react';
import {
  Bar, BarChart, CartesianGrid, Label, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis,
} from 'recharts';
import { formatNumberFR } from '../../utils/formatFR';
import Bloc from './Bloc';
import { AXE, COULEUR_MARCHE, GRILLE } from './couleurs';

const moisCourt = (mois) => {
  const [annee, numero] = String(mois).split('-');
  const noms = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.',
    'nov.', 'déc.'];
  return `${noms[Number(numero) - 1]} ${annee.slice(2)}`;
};

/** Nombre de ventes par mois — le portefeuille n'y figure jamais (lot DI § 5). */
export const GraphiqueVentes = ({ donnees, portefeuilleActif }) => {
  const points = (donnees.ventes_par_mois || []).map((m) => ({ ...m, libelle: moisCourt(m.mois) }));
  return (
    <Bloc
      titre="Nombre de ventes par mois"
      legende="Ventes de fonds de commerce publiées au BODACC, par mois de publication."
      testid="observatoire-graph-ventes"
    >
      <div className="h-64 -ml-2">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={points} margin={{ top: 8, right: 8, bottom: 28, left: 16 }}>
            <CartesianGrid strokeDasharray="3 3" stroke={GRILLE} vertical={false} />
            <XAxis dataKey="libelle" tick={{ fontSize: 11, fill: AXE }} interval="preserveStartEnd">
              <Label value="Mois de publication" position="insideBottom" offset={-18}
                     style={{ fontSize: 11, fill: AXE }} />
            </XAxis>
            <YAxis tick={{ fontSize: 11, fill: AXE }} allowDecimals={false} tickFormatter={formatNumberFR}>
              <Label value="Nombre de ventes" angle={-90} position="insideLeft" offset={-4}
                     style={{ fontSize: 11, fill: AXE, textAnchor: 'middle' }} />
            </YAxis>
            <Tooltip
              formatter={(valeur) => [`${formatNumberFR(valeur)} ventes`, 'Marché']}
              labelFormatter={(l) => `Publication : ${l}`}
              contentStyle={{ fontSize: 12, borderRadius: 8 }}
            />
            <Legend verticalAlign="top" height={24} wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="nombre" name="Ventes publiées (marché)" fill={COULEUR_MARCHE}
                 radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      {portefeuilleActif && (
        <p className="text-xs text-slate-500 mt-2" data-testid="observatoire-graph-ventes-note">
          Vos biens n'apparaissent pas ici : ce graphique compte des ventes datées, votre
          portefeuille des biens en vente aujourd'hui.
        </p>
      )}
    </Bloc>
  );
};

export default GraphiqueVentes;
